import { differenceInMonths, parseISO, startOfMonth } from 'date-fns';

const calcularMesesDiferencaNew = (dataEspecifica) => {
  const dataEspecificaDate = parseISO(dataEspecifica);
  const hoje = new Date();
  const formatado = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}`;

  const dataInicio = startOfMonth(dataEspecificaDate);
  const dataFim = startOfMonth(parseISO(formatado));

  const mesesDiferencaNew = differenceInMonths(dataInicio, dataFim);
  
  return mesesDiferencaNew;
};

function customRound(value) {
  return Math.round(value / 1000) * 1000; 
}

const calcularResultadoV5 = (credito, percentual, dataencerramento, debugMode) => {
  let valorDoBem = parseFloat(credito.replace(/\./g, '').replace(',', '.'));

  const valorPago = parseFloat(percentual.replace(',', '.'));
  const mesesDiferenca = calcularMesesDiferencaNew(dataencerramento);
  const valorRecebivel = valorDoBem * (valorPago / 100);
  let tipoCalculo = '';
  
  let resultadoCalculo = 0;
  let resultadoCalculoSemArredondamento = 0;
  
  console.log('--- NOVO CÁLCULO V5---');
  console.log('Valor do bem: ', valorDoBem);
  console.log('Valor do recebível: ', valorRecebivel);  
  console.log('Valor pago (porcentagem):', valorPago);
  console.log('Data de encerramento: ', dataencerramento);
  console.log('Meses de diferença: ', mesesDiferenca);
  
  let percentualProposta = 0;
  
  if(valorRecebivel >= 5000){//TABELA Única

    if(mesesDiferenca >= 1 && mesesDiferenca <= 70){    
      percentualProposta = 0.505 - (mesesDiferenca * 0.005);  
    }else if(mesesDiferenca >= 71 && mesesDiferenca <= 81){
      percentualProposta = 0.15;     
    }else if(mesesDiferenca >= 82 && mesesDiferenca <= 91){
      percentualProposta = 0.560 - (mesesDiferenca * 0.005);      
    }else{
      percentualProposta = 0.10;
    } 

  }/*else if(valorRecebivel >= 10000 && valorRecebivel <= 14999){//TABELA 2
    if(mesesDiferenca <= 61){
      percentualProposta = 0.405 - (mesesDiferenca * 0.005);
    }
    else{
      percentualProposta = 0.10;
    }
  }else if(valorRecebivel < 10000 && valorRecebivel >= 5000){//TABELA 3
    if(mesesDiferenca <= 41){
      percentualProposta = 0.305 - (mesesDiferenca * 0.005);
    }
    else{
      percentualProposta = 0.10;
    }
  }else if(valorRecebivel < 5000 && valorRecebivel >= 4000){//TABELA 4
    percentualProposta = 0.10;
  }*/
  console.log('Percentual da Proposta :', percentualProposta);

  resultadoCalculo = valorDoBem * (valorPago * percentualProposta / 100);
  resultadoCalculoSemArredondamento = valorDoBem * (valorPago * percentualProposta / 100);

  console.log('Resultado do cálculo (SEM ARREDONDAMENTO): ', resultadoCalculo);

  let lucro = 0;
  
  if (valorRecebivel >= 5000) {     
    tipoCalculo = 'Tabela Única - Recebível maior que R$5.000,00';  
    lucro = valorRecebivel - resultadoCalculo;     
  }/*else if (valorRecebivel >= 10000 && valorRecebivel <= 14999){
    tipoCalculo = 'Tabela 2 - Recebível entre R$10.000,00 e R$14.999,00';
    lucro = valorRecebivel - resultadoCalculo;
  }else if (valorRecebivel < 10000 && valorRecebivel >= 5000){
    tipoCalculo = 'Tabela 3 - Recebível menor que R$10.000,00';
    lucro = valorRecebivel - resultadoCalculo;
  }else if (valorRecebivel < 5000 && valorRecebivel >= 4000){
    tipoCalculo = 'Tabela 4 - Recebível entre R$4.000,00 e R$4.999,00';
    lucro = valorRecebivel - resultadoCalculo;
  }*/else{
    tipoCalculo = 'RECUSADO - Recebível menor que R$5.000,00';
    console.log('RECUSADO: LUCRO; VALOR='+lucro);
    console.log('RECUSADO: Recebível menor que 5000; VALOR='+valorRecebivel);
  }

  if(lucro < 5000){
    resultadoCalculo = 0;
    console.log('RECUSADO: Lucro menor que 5000; VALOR='+lucro);
  }else{
    resultadoCalculo = customRound(resultadoCalculo);
  }

  if(mesesDiferenca <= 3 || mesesDiferenca > 120){
    resultadoCalculo = 0;
    tipoCalculo = 'RECUSADO - Meses de diferença menor que 3 ou maior que 120';
    console.log('RECUSADO: Meses de diferença menor que 3 ou maior que 120');
  }
  
  console.log('Lucro bruto: ', lucro);
  console.log('Resultado do cálculo (AREDONDADO): ', resultadoCalculo);

  const dataResultado = {
    valorPago,
    valorRecebivel,
    mesesDiferenca,
    percentualProposta,
    lucro,
    resultadoCalculo,
    resultadoCalculoSemArredondamento,
    tipoCalculo,
  };

  return dataResultado;
};


export default calcularResultadoV5;
